import React, {useState} from "react";
import moment from 'moment';
import 'moment/locale/bg';  // without this line it didn't work
import { Divider, Modal, Button } from 'rsuite';
import { isPolicyAdded}  from '../../../../app/common/services/vehicle.service';
import { downloadFile } from "../../../../app/common/services/fetch.service";
import {BackIcon, Car, QuestionIcon, DolwnloadIcon} from '../../../pages/components/svg/iconsSvg';
import InsCompLogos from '../../../pages/components/svg/insCompLogos';
import {insCompBgNames} from '../../../../app/common/types/insCompTypes';
import { regPropsBG} from '../../../../app/common/types/vehicleTypes';
import CashFlowDetails from './elements/CashFlowDetails';
import CustomDrawer from '../../../pages/components/elements/CustomDrawer';

const MyPolicyDetail = ({policy, onBack, style}) => {

    const [showInfo, setShowInfo] = useState(false);
    const [showRegProps, setShowRegProps] = useState(false);

    const policyExpireDate = moment(policy?.expireDate).format('DD MMMM');
    const policyExpireYear =  moment(policy?.expireDate).format('YYYY');

    const insCompany = policy?.insCompany;

    const CompanyLogo   = InsCompLogos[insCompany] ? InsCompLogos[insCompany]() : null;
    const CompanyNameBG  = insCompBgNames[insCompany];

    const {make, model, plate} = policy?.registrationProps || {};
    const vechicleMake = make ? `${make.value} ${model?.value}` : null;
    const vechiclePlate = plate ? ` ${plate?.value}` : null;

    const cashflows = policy?.cashflows || [];

    console.log(cashflows)

    const registrationProps = policy?.registrationProps;

    const goBack = () => onBack(1);

    const closeInfo = () => setShowInfo(false);

    const hideRegProps = () => setShowRegProps(false);

    const onShowRegProps = (event) => {
        event.stopPropagation();
        setShowRegProps(true);
    }

    //console.log(policy)

    const downloadPolicy = () => {
        if(!policy?.insuranceDocuments) return;
        const doc = policy?.insuranceDocuments.find(doc => (doc.docType === "POLICY"));
        const fileUploadId = doc ? doc.fileUploadId : null;
        if(!fileUploadId) return;
        const contentType = doc?.contentType;
        const fileName = contentType === "application/pdf" ? 'Policy.pdf': 'Policy.png';

        downloadFile(fileUploadId).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); //or any other extension
            document.body.appendChild(link);
            link.click();
        });
    }

    const renderPolicyText = () => {
        return isPolicyAdded(policy) 
        ? <div className="info">
            <span>Полицата е добавена </span>
            <i onClick={()=>setShowInfo(true)}><QuestionIcon size="16" style={{marginLeft: '2px'}}/></i>
        </div>
        : 'Полица'
        
    }

    const renderCashFlows = () => {
        return cashflows.map((cashflow, i) => {
            return <div key={i+1}>
                <CashFlowDetails policy={policy} cashflow={cashflow} />
            </div>
        })
    }

    const renderTalonData = () => {
        if(!registrationProps || !Object.keys(registrationProps).length) return <p className="custom-drawer-data">Няма намерени данни.</p>;

        return Object.keys(registrationProps).reduce((acc, key, i) => {
            if(Object.keys(regPropsBG).includes(key)) {
                const addedtext = (key === 'maxPower') ? 'kW' : (key === 'engineCapacity') ? 'куб.см' : null;

                return [...acc, <div className="custom-drawer-data" key={i}>{[regPropsBG[key]]}: <span className="bold">{registrationProps[key].userValue} <span>{addedtext}</span></span></div> ]
            }

            return acc;
        }, [])
    }

    return (<>
        <div className="steps_container green-divider" style={style}>
            <div className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Моите полици</h6>
            </div>
            <Divider style={{marginBottom: 0}}/>
            <div className="policy-detail" >
                <div className="first-row" >
                    <div className="left">
                        <h6>Гражданска отговорност</h6> 
                        <div style={"armeetz_bulstrad_bulins_levins_dzi".includes(insCompany) ? {marginLeft:'-1.3rem'} : null}>
                            {CompanyLogo}
                        </div>
                        <p>{CompanyNameBG}</p>
                    </div>
                    <div className="right">
                        <h6>{policyExpireDate}</h6>
                        <p>{policyExpireYear}</p>
                    </div>
                </div>
            </div>
            <div className="policy-detail" >
                <div className="second-row">
                    <div >
                        <Car size={90} />
                    </div>
                    <div >
                        <h6>Рег. номер</h6>
                        <p>{vechiclePlate}</p>
                        <h6 style={{marginTop: '12px'}}>МПС</h6>
                        <p className="blue" style={{cursor: 'pointer'}} onClick={onShowRegProps}>{vechicleMake}</p>                        
                    </div>
                </div>
                <h6 style={{marginTop: '12px'}}>{renderPolicyText()}</h6>
                <div className="policy" onClick={downloadPolicy}>
                    <DolwnloadIcon size={16}/>
                    <p className="blue link" >{policy?.policyId}</p>
                </div>
                {(insCompany !== 'levins' && !isPolicyAdded(policy))
                ?<>
                    <h6 style={{marginTop: '12px'}}>Информационен документ</h6>
                    <a className="policy" href={`/files/conditions/${insCompany}.pdf`} download rel="noreferrer">
                        <DolwnloadIcon size={16}/>
                        <p className="blue link" >Застраховка гражданска отговорност</p>
                    </a>
                </>
                : null}
            </div>
            {renderCashFlows()}

            <CustomDrawer show={showRegProps} close={hideRegProps} headerText="Данни на МПС от талон">
                {renderTalonData()}
            </CustomDrawer>
        </div>

        <Modal size="xs" show={showInfo} onHide={closeInfo}>
            <Modal.Header>
                <Modal.Title> <div><QuestionIcon size="16" style={{marginLeft: '2px'}}/></div></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: '0px', marginTop: '16px', marginBottom: '20px' }}>
                <div >  
                      <p style={{padding: '0 8px', marginBottom: '16px'}}>Полицата е добавена в приложението с цел плащане на поредна вноска и получаване на известие при изтичането ѝ. Тъй като не е сключена през Nu INS може да липсва следната информация:</p>
                      <ol>
                          <li>Марка и модел на автомобила</li>
                          <li>Полицата като документ</li>
                          <li>Информационен документ на застрахователя</li>
                      </ol>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={closeInfo} appearance="subtle">
                Ok
                </Button>
            </Modal.Footer>
        </Modal>
        </>
    )    
}

export default MyPolicyDetail;